export enum StoreNamespace {
  identity = 'identity/current',
  identityWaiting='identity/waiting',
  certificateContent = 'certificate/content',
  certificateIssuer = 'certificate/issuer',
  certificateIds='certificates/ids',
  messages='messages'
}
